(() => {
  const sliders = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = 'IntersectionObserver' in window && !reducedMotion.matches && !window.Shopify?.designMode
    ? new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('myurein-reveal-pending');
      entry.target.classList.add('myurein-reveal-visible');
      observer.unobserve(entry.target);
    }), { threshold: 0.08 }) : null;
  function init(root = document) {
    if (observer) root.querySelectorAll('[data-myurein-reveal]').forEach(el => {
      if (el.classList.contains('myurein-reveal-visible')) return;
      el.classList.add('myurein-reveal-pending');
      observer.observe(el);
    });
    root.querySelectorAll('.myurein-featured').forEach(el => {
      if (sliders.has(el)) return;
      const track = el.querySelector('[data-myurein-track]');
      const prev = el.querySelector('[data-myurein-prev]');
      const next = el.querySelector('[data-myurein-next]');
      if (!track || !prev || !next) return;
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      const resize = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
      resize?.observe(track); update(); sliders.set(el, { resize });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-myurein-reveal]').forEach(el => observer?.unobserve(el));
    event.target.querySelectorAll('.myurein-featured').forEach(el => { sliders.get(el)?.resize?.disconnect(); sliders.delete(el); });
  });
})();

/* Use the same three collection sort choices for old links and default sorting. */
(() => {
  function normalizeCollectionSort() {
    if (window.Shopify?.designMode || !location.pathname.startsWith('/collections/')) return;
    const select = document.querySelector('select[data-myurein-current-sort]');
    if (!select) return;
    const url = new URL(location.href);
    const current = url.searchParams.get('sort_by') || select.dataset.myureinCurrentSort;
    if (['manual', 'price-ascending', 'price-descending'].includes(current)) return;
    url.searchParams.set('sort_by', 'manual');
    url.searchParams.delete('page');
    location.replace(url.href);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeCollectionSort);
  else normalizeCollectionSort();
})();
